import React, { useState } from "react";
import {
  Col,
  Row,
  Typography, Form,
  Input,
  Button,
  Select,
  Layout,
  Avatar, Upload,
  DatePicker,
  Skeleton
} from "../../components/ui";
import { TextArea } from "../../components/ui";
import { useDeleteTeacher, useGetClassrooms, useGetTeacherById, useUpdateTeacher } from "../../query/teacherQuery";
import dayjs from "dayjs";
import { FaArrowLeft } from "react-icons/fa";
import avatar from "../../assets/avatar.png";
import { UPLOADS_URL } from "../../config/constants";
import { useNavigate, useParams } from "react-router-dom";
import TeacherProfile from "./TeacherProfile";
import { CloseCircleOutlined, PlusOutlined } from "../../components/Icons";
import swal from "../../utils/swal";
import { TbCameraPlus } from "react-icons/tb";



function TeacherDetails() {
  const navigate = useNavigate();
  const { Option } = Select;
  const { id } = useParams();
  const {isLoading,data:teacher}  = useGetTeacherById(id);
  const { data: classrooms } = useGetClassrooms();
  const {mutate:updateTeacher, isPending: isMutating} = useUpdateTeacher();
  const {mutate:deleteTeacher} = useDeleteTeacher();
  const [editMode, setEditMode] = useState(false);
  const [imageOld, setImageOld] = useState();
  const [imageNew, setImageNew] = useState()

  const handleDelete = async () => {
    if (teacher?.classroom?._id || teacher?.classroom) {
      const className = teacher?.classroom?.classroomName || "a class";
      swal(
        "Cannot delete",
        `This teacher is assigned to ${className}. Unassign the classroom first.`,
        "warning"
      );
      return;
    }

    swal({
      title: "Are you sure?",
      text: "Do you want to delete this Teacher?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        try {
            deleteTeacher(id, {
        onSuccess: () => {
          swal("Success", "Teacher deleted successfully", "success");
          navigate(-1);
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete teacher", "error");
        },
      });
        } catch (err) {
          console.log(err);
        }
      } else {
       console.log("Cancelled");
      }
    });

   
  };  


  const onFinish = (values) => {
    const formObject = new FormData();

    if (imageNew) {
      formObject.append("image", imageOld);
    }

    // Append education data
    let _education = [...values.education].map((item, index) => ({
      school: item.school,
      subject: item.subject.split(",").map((value) => value.trim()),
      start: item.start,
      end: item.end,
    }));

    formObject.append("education", JSON.stringify(_education));
    formObject.append("employment", JSON.stringify(values.employment));


    for (const key in values) {
      if (key !== "education" && key !== "employment" && key !== "image") {
        const item = values[key];
        formObject.append(key, item);
      }
    }

    updateTeacher({teacherId:id,data:formObject},{
      onSuccess: () => {
        setEditMode(false);
        swal("Success", "Teacher updated successfully", "success");
      },
      onError: (error) => {
        swal("Error", error?.message, "error");
      },
    });
    };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={editMode ? undefined : { background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {editMode && (
        <Row style={{ padding: "10px" }}>
          <Col
            xs={24}
            md={12}
            style={{ display: "flex", alignItems: "center" }}
          >
            <FaArrowLeft
              style={{ fontWeight: "bold", fontSize: "20px", cursor: "pointer" }}
              onClick={() => setEditMode(false)}
            />
            &emsp;
            <h1 className="pageTitle" style={{ margin: 0 }}>
              Edit Teacher
            </h1>
          </Col>
        </Row>
        )}

        {isLoading  && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              marginBottom: "20px",
              marginTop: "20px",

            }}
          >
            <br />            <br />

            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && teacher && (
          <>
            {editMode ? <Form
              layout="vertical"
              name="basic"
              className="contactForm"
              labelCol={{
                span: 0,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >

              <Row gutter={20} style={{ padding: "10px 20px" }}>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Form.Item name="image">
                    <Upload
                      name="image"
                      showUploadList={false}
                      style={{ position: "relative" }}
                      beforeUpload={(file) => {
                        setImageOld(file)
                        setImageNew(URL.createObjectURL(file));
                        return false;
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          padding: "8px",
                          position: "absolute",
                          right: -10,
                          zIndex: 2,
                          bottom: 40,
                          backgroundColor: "#243D62",
                          display: "flex",
                          maxWidth: "fit-content",
                          color: "white",
                          borderRadius: "20px",
                        }}
                      >
                        <TbCameraPlus />
                      </div>{" "}
                      <Avatar
                        size={120}
                        src={
                          imageNew
                            ? imageNew
                            : !teacher?.image
                              ? avatar
                              : UPLOADS_URL + "/" + teacher?.image
                        }
                      />
                    </Upload>
                  </Form.Item>
                  <br />
                </Col>
              </Row>



              <Row gutter={20} style={{ padding: "0px 20px" }}>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Teacher ID :
                  </Typography.Title>

                  <Form.Item
                    name="teacherId"
                    initialValue={teacher?.teacherId}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input your Teacher Id",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Teacher Id"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Classroom :
                  </Typography.Title>

                  <Form.Item
                    name="classroom"
                    initialValue={teacher?.classroom?._id}
                    style={{ width: "100%", height: "40px" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select Classroom",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Classroom"
                      className="signupSelectBox"
                    >
                      {classrooms.length > 0 && classrooms.map((item, index) => {
                        return (<Option value={item._id}>{`${item.classroomName} (${item.classroomId})`}</Option>)
                      })}

                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    First Name :
                  </Typography.Title>

                  <Form.Item
                    name="firstName"
                    initialValue={teacher?.firstName}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input First Name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter First Name"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20} style={{ padding: "0px 20px" }}>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Last Name :
                  </Typography.Title>

                  <Form.Item
                    name="lastName"
                    initialValue={teacher?.lastName}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Last Name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Last Name"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Email :
                  </Typography.Title>

                  <Form.Item
                    name="email"
                    initialValue={teacher?.email}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Email",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Email"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Phone Number :
                  </Typography.Title>

                  <Form.Item
                    name="phone"
                    initialValue={teacher?.phone}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Phone Number",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      
                      placeholder="Enter Phone Number"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={20} style={{ padding: "0px 20px" }}>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Address
                  </Typography.Title>

                  <Form.Item
                    name="address"
                    initialValue={teacher?.address}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input address",
                      },
                    ]}
                  >
                    <Input

                      size="large"
                      placeholder="Enter address"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    City
                  </Typography.Title>

                  <Form.Item
                    name="city"
                    initialValue={teacher?.city}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input city",
                      },
                    ]}
                  >
                    <Input

                      size="large"
                      placeholder="Enter city"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    State
                  </Typography.Title>

                  <Form.Item
                    name="state"
                    initialValue={teacher?.state}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input state",
                      },
                    ]}
                  >
                    <Input

                      size="large"
                      placeholder="Enter state"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Zip Code
                  </Typography.Title>

                  <Form.Item
                    name="zip"
                    initialValue={teacher?.zip}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input zipcode",
                      },
                    ]}
                  >
                    <Input

                      size="large"
                      placeholder="Enter zip code"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                
              </Row>


              <Row gutter={20} style={{ padding: "0px 20px" }}>

                <Col
                  xs={24}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Bio:
                  </Typography.Title>

                  <Form.Item
                    name="bio"
                    initialValue={teacher?.bio}
                    style={{ width: "100%" }}
                  >
                    <TextArea
                      size="large"
                      rows={5}
                      placeholder="Enter Bio"
                      className="signupFormInput2"
                    />
                  </Form.Item>
                </Col>




                {/* <Col
    xs={24}
    sm={8}
    style={{ display: "flex", alignItems: "flex-start",flexDirection:'column' }}
  >
    <Typography.Title
      className="fontFamily1"
      style={{
        fontSize: "16px",
        fontWeight: 600,
        color: "black",
        textAlign: "left",
        marginBottom: 20,
      }}
    >
      Features :
    </Typography.Title>
 
    <Form.Item
      name="features"
      initialValue={teacher?.features}
      style={{ width: "100%" }}
      rules={[
        {
          required: true,
          message: "Please input Features",
        },
      ]}
    >
      <Input
        size="large"
        placeholder="Enter Features"
        className="signupFormInput"
      />
    </Form.Item>
  </Col> */}

              </Row>
              <br />
              <hr style={{ margin: "0px 20px", borderWidth: 1, }} />
              <br />
              <Row gutter={20} style={{ padding: "0px 20px" }}>

                <Col
                  xs={24}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "black",
                      textDecoration: "underline",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Educational Details
                  </Typography.Title>
                  <Row>

                    <Form.List
                      name="education"
                      initialValue={teacher?.education.map(item => { return ({ ...item, start: dayjs(item.start), end: dayjs(item.end), subject: item.subject.join(",") }) })}
                    >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <>
                              {" "}
                              <Row
                                key={key}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: 20,
                                  padding: "0px 20px",
                                  width: "100%",
                                }}
                              >
                                <Typography.Text
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    textDecoration: "underline",
                                    color: "#3C3C3B",
                                    textAlign: "left",
                                    marginTop: 0,
                                  }}
                                >
                                  Education {index + 1}
                                </Typography.Text>{" "}
                                &emsp;
                                <CloseCircleOutlined
                                  onClick={() => remove(name)}
                                  style={{ color: "#B00000", fontSize: "20px" }}
                                />

                              </Row>
                              <Row key={key} gutter={20} style={{ padding: "0px 20px" }}>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Institution Name*"
                                    name={[name, "school"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter institution name ",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter institution name"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Start Date*"
                                    name={[name, "start"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter start date ",
                                      },
                                    ]}
                                  >

                                    <DatePicker
                                      style={{ width: "100%" }}

                                      size="large"
                                      placeholder="Enter start date"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>

                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="End Date*"
                                    name={[name, "end"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter end date ",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      style={{ width: "100%" }}

                                      size="large"
                                      placeholder="Enter end date"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>

                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Subject Studied*"
                                    name={[name, "subject"]}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please enter coma seperated subjects",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter subject Studied (coma seperated)"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Row style={{ width: "100%", padding: "0px 20px", }}>
                                {index + 1 < fields.length && (

                                  <hr
                                    style={{
                                      width: "100%",
                                      marginBottom: 20,
                                      borderTop: "none",
                                      borderBottom: "1px dashed grey",
                                    }}
                                  />

                                )}
                              </Row>
                            </>
                          ))}
                          <Form.Item style={{ padding: "0px 20px", }}>
                            <Button
                              type="dashed"
                              size="large"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Educational Details
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </Row>


                </Col>

              </Row>
              <br />
              <hr style={{ margin: "0px 20px", borderWidth: 1, }} />
              <br />
              <Row gutter={20} style={{ padding: "0px 20px" }}>

                <Col
                  xs={24}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "black",
                      textDecoration: "underline",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Former Employment
                  </Typography.Title>
                  <Row>

                    <Form.List
                      name="employment"
                      initialValue={teacher?.employment.map(item => { return ({ ...item, start: dayjs(item.start), end: dayjs(item.end), position: item.position }) })}
                    >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <>
                              {" "}
                              <Row
                                key={key}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: 20,
                                  padding: "0px 20px",
                                  width:"100%"
                                }}
                              >
                                <Typography.Text
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    textDecoration: "underline",
                                    color: "#3C3C3B",
                                    textAlign: "left",
                                    marginTop: 0,
                                  }}
                                >
                                  Employment {index + 1}
                                </Typography.Text>{" "}
                                &emsp;
                                <CloseCircleOutlined
                                  onClick={() => remove(name)}
                                  style={{ color: "#B00000", fontSize: "20px" }}
                                />

                              </Row>
                              <Row key={key} gutter={20} style={{ padding: "0px 20px" }} >
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Organization Name*"
                                    name={[name, "school"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter organization name ",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter institution name"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Start Date*"
                                    name={[name, "start"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter start date ",
                                      },
                                    ]}
                                  >

                                    <DatePicker
                                      style={{ width: "100%" }}

                                      size="large"
                                      placeholder="Enter start date"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>

                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="End Date*"
                                    name={[name, "end"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please enter end date ",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      style={{ width: "100%" }}

                                      size="large"
                                      placeholder="Enter end date"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>

                                <Col xs={24} md={12}>
                                  <Form.Item
                                    {...restField}
                                    label="Position*"
                                    name={[name, "position"]}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please enter position",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter job position"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>


                              </Row>
                              <Row style={{ width: "100%", padding: "0px 20px", }}>
                                {index + 1 < fields.length && (

                                  <hr
                                    style={{
                                      width: "100%",
                                      marginBottom: 20,
                                      borderTop: "none",
                                      borderBottom: "1px dashed grey",
                                    }}
                                  />

                                )}
                              </Row>
                            </>
                          ))}
                          <Form.Item style={{ padding: "0px 20px", }}>
                            <Button
                              type="dashed"
                              size="large"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Employment Details
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </Row>


                </Col>

              </Row>
              <Row style={{ padding: "10px 20px" }}>
                <Form.Item label={null}>
                  <Button type="primary" htmlType="submit" className="saveBtn" disabled={isMutating}>
                    {isMutating ? "Loading..." : "Save"}
                  </Button>&emsp;<Button
                    type="primary"
                    htmlType="submit"
                    className="cancelBtn"
                    ghost
                    onClick={() => setEditMode(false)}

                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Row>

            </Form> : (
              <TeacherProfile
                teacher={teacher}
                onDelete={handleDelete}
              />
            )}

          </>
        )}
      </div>
    </Layout>
  );  
}
export default TeacherDetails;
